import { authHeader } from '@/_helpers';

export const opportunitiesService = {
    getAll,
    getAllByFilter,
    getPriority,
    getOpportunityById,
    getDashboardData,
    getDashboardTotals,
    getClients,
    changeStatus,
    unlockContactsOpportunity,
    createOpportunity,
    getListOpportunities,
    getContacts,
    getSessions,
    refuse,
    getBusinessesFilter,
    getDataToCsv,
    getActivityLink,
    getAbsentMeetingTreatmentLinks,
    attachEventToThisOpportunity,
    setUserBDR,
    getBookersHistory,
    autoLink,
    getNextTask,
    checkOpportunityToTask,
    getPhoneLookup,
    getCurrentTime,
    getProspectTimezone,
    getOpprtunityByPhone,
    setTaskandRemembers,
    getBookersCallStatistics,
    getAllPossibleMeetings,
    getAttendaceStattistics,
    ringoverTranscriptionByNotification,
    getMeetingRecordingsAnalysis,
    getMeetingRecordingMediaByBotId,
    getMeetingRetestData,
    testMeetingRetestPrompt,
    saveMeetingRetestPrompt,
    applyMeetingRetestAnalysis,
    getMeetingCoachingData,
    testMeetingCoachingPrompt,
    saveMeetingCoachingPrompt,
    applyMeetingCoachingAnalysis,
    getPaginationActivitiesOpportunities,
    appendActivities2ToOpportunity,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getAll(currentPage, cantPerPage, searchFilter, productFilter, parentCategoryFilter, linkStatusFilter, salesUserFilter, orderBy, businessFilter, tagFilter) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/filtered-list?currentPage=${currentPage}&cantPerPage=${cantPerPage}&searchFilter=${searchFilter}&productFilter=${productFilter}&parentCategoryFilter=${parentCategoryFilter}&linkStatusFilter=${linkStatusFilter}&salesUserFilter=${salesUserFilter}&orderBy=${orderBy}&businessFilter=${businessFilter}&tagFilter=${tagFilter}`, requestOptions).then(handleResponse);
}

function getAllPossibleMeetings(link_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')    
  }
  return fetch(`${apiUrl}/admin/events/${link_id}`, requestOptions).then(handleResponse)

}

function setTaskandRemembers(link_id){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({link_id})
    };
    return fetch(`${apiUrl}/opportunities/delete-tasks-todo`, requestOptions).then(handleResponse);
}


function getProspectTimezone(email_response_id, user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  const params = new URLSearchParams({ email_response_id: email_response_id || '', user_id: user_id || '' });
  return fetch(`${apiUrl}/opportunities/prospect-timezone?${params}`, requestOptions).then(handleResponse);
}

function getCurrentTime() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/opportunities/get-current-time`, requestOptions).then(
    handleResponse,
  )
}

function getOpprtunityByPhone($phone) {
    const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json'),
    }
    return fetch(`${apiUrl}/opportunities/get-opportunity-by-phone?phone=${$phone}`, requestOptions).then(
      handleResponse,
    )
  }



function getAllByFilter(currentPage, cantPerPage, searchFilter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ currentPage, cantPerPage, searchFilter })
    };
    return fetch(`${apiUrl}/opportunities/filtered-list`, requestOptions).then(handleResponse);
}

function getActivityLink(id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ linkid: id })
    };
    return fetch(`${apiUrl}/links/getactivitylink`, requestOptions).then(handleResponse);
}


function refuse(link_id, message) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ link_id, message })
    };
    return fetch(`${apiUrl}/links/refuse`, requestOptions).then(handleResponse);
}


function getListOpportunities(searchFilter, client_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/searched-list?searchFilter=${searchFilter}&clientId=${client_id}`, requestOptions).then(handleResponse);
}


function getSessions(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/${id}/session`, requestOptions).then(handleResponse);
}

function getPriority(parentCategoryFilter, productFilter) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    // Agusdeluca96: return fetch(`${apiUrl}/opportunities/priority?categoryFilter=${categoryFilter.id}&productFilter=${productFilter.id}`, requestOptions)
    return fetch(`${apiUrl}/opportunities/priority?productFilter=${productFilter.id}`, requestOptions)
        .then(handleResponse)
        .then(opportunity => mergeOpportunityCommentsAndEvents(opportunity));
}

function getOpportunityById(id, notification_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/${id}?notification_id=${notification_id}`, requestOptions)
        .then(handleResponse)
        .then(opportunity => mergeOpportunityCommentsAndEvents(opportunity));
}

function getDashboardData() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/dashboard`, requestOptions)
        .then(handleResponse);
}

function getDashboardTotals() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/dashboard/totals`, requestOptions)
        .then(handleResponse);
}

function getClients() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/clients/users`, requestOptions)
        .then(handleResponse);
}

function getDataToCsv(searchFilter) {
    let currentPage = 1;
    let cantPerPage = 1000000;
    searchFilter.total = 0;
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ currentPage, cantPerPage, searchFilter })
    };
    return fetch(`${apiUrl}/opportunities/filtered-list`, requestOptions).then(handleResponse);
}



function autoLink(email_id, email_to, id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ email_id, email_to, id })
    };
    return fetch(`${apiUrl}/links/attach`, requestOptions).then(handleResponse);

}


function getBusinessesFilter() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };

    return fetch(`${apiUrl}/opportunities/businesses-filter`, requestOptions).then(handleResponse);
}



function unlockContactsOpportunity(linkId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            linkId: linkId,
        })
    };
    return fetch(`${apiUrl}/opportunities/${linkId}/unlockcontacts`, requestOptions).then(handleResponse);
}

function changeStatus(statusId, linkId, linkStatusReasonId, nextCampaignId, nextCampaignDatetime, initDelay) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            link_status_reason_id: linkStatusReasonId,
            next_campaign_id: nextCampaignId,
            next_campaign_datetime: nextCampaignDatetime,
            status_id: statusId,
            init_delay: initDelay
        })
    };
    return fetch(`${apiUrl}/opportunities/${linkId}/changestatus`, requestOptions).then(handleResponse);
}

function createOpportunity(businessId, campaignId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            business_id: businessId,
            campaign_id: campaignId
        })
    };
    return fetch(`${apiUrl}/opportunities/`, requestOptions).then(handleResponse);
}

function attachEventToThisOpportunity(linkIdFrom, linkIdTo) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            link_id_from: linkIdFrom,
            link_id_to: linkIdTo
        })
    };
    return fetch(`${apiUrl}/opportunities/attachEventToLink`, requestOptions).then(handleResponse);
}

function getContacts(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/${id}/contacts`, requestOptions).then(handleResponse);
}

function getMeetingRecordingsAnalysis(linkId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/${linkId}`, requestOptions).then(handleResponse);
}

function getMeetingRecordingMediaByBotId(botId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/media/${botId}`, requestOptions).then(handleResponse);
}

function getMeetingRetestData(meetingRecordingId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/retest/${meetingRecordingId}`, requestOptions).then(handleResponse);
}

function testMeetingRetestPrompt(meeting_recording_id, prompt) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/retest/test`, requestOptions).then(handleResponse);
}

function saveMeetingRetestPrompt(meeting_recording_id, prompt) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/retest/save-prompt`, requestOptions).then(handleResponse);
}

function applyMeetingRetestAnalysis(meeting_recording_id, prompt, parsed, raw_result) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt, parsed, raw_result }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/retest/apply`, requestOptions).then(handleResponse);
}

function getMeetingCoachingData(meetingRecordingId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/coaching/${meetingRecordingId}`, requestOptions).then(handleResponse);
}

function testMeetingCoachingPrompt(meeting_recording_id, prompt) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/coaching/test`, requestOptions).then(handleResponse);
}

function saveMeetingCoachingPrompt(meeting_recording_id, prompt) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/coaching/save-prompt`, requestOptions).then(handleResponse);
}

function applyMeetingCoachingAnalysis(meeting_recording_id, prompt, parsed, raw_result) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ meeting_recording_id, prompt, parsed, raw_result }),
    };
    return fetch(`${apiUrl}/opportunities/meeting-recordings/coaching/apply`, requestOptions).then(handleResponse);
}

function ringoverTranscriptionByNotification(notification_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ notification_id }),
    };
    return fetch(`${apiUrl}/links/ringover-transcription-by-notification`, requestOptions).then(handleResponse);
}

function getNextTask(totals = 0) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/get-next-task?totals=${totals}`, requestOptions).then(handleResponse);
}

function checkOpportunityToTask(opportunityId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };

    return fetch(`${apiUrl}/opportunities/check?opportunity_id=${opportunityId}`, requestOptions)
        .then(handleResponse);
}


function getPhoneLookup(active, count = 0, searchFilter = 0) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            active,
            count,
            searchFilter: {...searchFilter}
        })
    };

    return fetch(`${apiUrl}/links/phone-lookup?count=${count}&active=${active}`, requestOptions)
        .then(handleResponse);
}


function getAbsentMeetingTreatmentLinks() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/0/absent-meeting-treatment`, requestOptions).then(handleResponse);
}

function setUserBDR(link_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({
            link_id
        })
    };
    return fetch(`${apiUrl}/opportunities/set-user-bdr`, requestOptions).then(handleResponse);
}



function getBookersCallStatistics(searchFilter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({searchFilter})
    };
    return fetch(`${apiUrl}/opportunities/bookers-call-statistics`, requestOptions).then(handleResponse);
}

function getAttendaceStattistics(searchFilter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({searchFilter})
    };
    return fetch(`${apiUrl}/opportunities/attendance-statistics`, requestOptions).then(handleResponse);
}

function getBookersHistory(searchFilter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({searchFilter})
    };
    return fetch(`${apiUrl}/opportunities/bookers-history`, requestOptions).then(handleResponse);
}

function getPaginationActivitiesOpportunities(link_id, offset = 50, limit = 51) {
    const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/opportunities/${link_id}/activities2?limit=${limit}&offset=${offset}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (response.data !== 204) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
    }
}

function buildTimelineFromActivities2(timeline) {
    var timelinePassed = []
    var timelineComming = []
    var timelineTask = []
    var timelinePassedAct = []
    var user_idant = false
    var typeant = false

    timeline.forEach(item => {

        var pastevent = false;
        // Preparo la fecha en un formato comparable
        if (item.type == "event") {
            var commentDateArray = item.event_date.split(/-|\s|:/);
            var commentDate = new Date(commentDateArray[0], commentDateArray[1] - 1, commentDateArray[2], commentDateArray[3], commentDateArray[4], commentDateArray[5]);
            // Verifico si el comment ya pasó o no para agregarlo en el arreglo que corresponda
            if (commentDate <= new Date()) {
                pastevent = true;
            }
        }

        if (item.type == 'task') {
            timelineTask.push(item)

            // Las tareas se procesan como elementos del timeline pasado
            // Se agregan directamente al timeline cronológico principal
            if (timelinePassedAct.length > 0) {
                var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
                itemdemolink.activities = timelinePassedAct
                timelinePassed.push(itemdemolink)
                timelinePassedAct = []
            }
            timelinePassed.push(item)
        }

        if (item.type == 'emailssent') {
            if (item.photo != null)
                item.photo = item.photo.split(",");

            item.opendate = []
            if (item.unlocked != null && item.unlocked != '') { //emailopen
                item.opendate = item.unlocked.split(",");
                item.from = item.response_from.split(",");
            }
        }
        if ((item.type != "event" && item.type != "emailscheduled" && item.type != "task") || pastevent) {
            if (item.link == "createdopportunity") {

                if (timelinePassedAct.length > 0) {
                    var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
                    itemdemolink.activities = timelinePassedAct
                    timelinePassed.push(itemdemolink)
                }

                timelinePassed.push(item)
            } else {



                if (item.type == 'activity') {
                    var pusshed = false
                    if (!user_idant) {
                        user_idant = item.id
                    } else {
                        if (item.id && user_idant != item.id) {

                            if (timelinePassedAct.length > 0) {
                                var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
                                itemdemolink.activities = timelinePassedAct
                                timelinePassed.push(itemdemolink)
                                timelinePassedAct = []
                                pusshed = true
                            }

                            user_idant = item.id
                        }
                    }

                    if (!pusshed) {
                        if (!typeant) {
                            typeant = item.link_activity_type_id
                        }
                        if (item.link_activity_type_id == 1 && typeant == 2) {

                            if (timelinePassedAct.length > 0) {
                                var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
                                itemdemolink.activities = timelinePassedAct
                                timelinePassed.push(itemdemolink)
                                timelinePassedAct = []
                            }

                        }
                        typeant = item.link_activity_type_id
                    }




                    timelinePassedAct.push(item)
                } else {
                    if (timelinePassedAct.length > 0) {
                        var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
                        itemdemolink.activities = timelinePassedAct
                        timelinePassed.push(itemdemolink)
                        timelinePassedAct = []
                    }
                    timelinePassed.push(item)

                }
            }

        }

        if (item.type == 'emailscheduled' && item.event_date != null) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            // Preparo la fecha en un formato comparable
            var commentDateArray = item.event_date.split(/-|\s|:/);
            var commentDate = new Date(commentDateArray[0], commentDateArray[1] - 1, commentDateArray[2], commentDateArray[3], commentDateArray[4], commentDateArray[5]);
            // Verifico si el comment ya pasó o no para agregarlo en el arreglo que corresponda
            if (commentDate > today) {
                timelineComming.push(item)
            }
        }

        if (item.type == 'event' && item.event_date != null) {
            var today = new Date();
            // Preparo la fecha en un formato comparable
            var commentDateArray = item.event_date.split(/-|\s|:/);
            var commentDate = new Date(commentDateArray[0], commentDateArray[1] - 1, commentDateArray[2], commentDateArray[3], commentDateArray[4], commentDateArray[5]);
            // Verifico si el comment ya pasó o no para agregarlo en el arreglo que corresponda
            if (commentDate > today && !(item.status == 'canceled' && timelineComming.length >= 1)) {
                timelineComming.push(item)
            }
        }

    });

    if (timelinePassedAct.length > 0) {
        var itemdemolink = timelinePassedAct[timelinePassedAct.length - 1]
        itemdemolink.activities = timelinePassedAct
        timelinePassed.push(itemdemolink)
    }

    return {
        timelinePassed,
        timelineComming,
        timelineTask,
    }
}

function appendActivities2ToOpportunity(opportunity, items) {
    if (!items || items.length === 0) {
        return opportunity
    }

    const built = buildTimelineFromActivities2(items)
    opportunity.timelinePassed.push(...built.timelinePassed)
    opportunity.timelineComming.push(...built.timelineComming)
    opportunity.timelineTask.push(...built.timelineTask)

    return opportunity
}

function mergeOpportunityCommentsAndEvents(opportunity) {
    if (opportunity.emails !== undefined) {
        var emailsResult = {}
        opportunity.emails.forEach(item => {
            emailsResult[item.id] = item
        });
        opportunity.emails = emailsResult
    }
    if (opportunity !== "" && opportunity !== null && opportunity != {}) {

        const timeline = opportunity.activities2
        opportunity.timelineRecent = []
        opportunity.timelineRecent = opportunity.activities
        opportunity.timelineComming = []
        opportunity.timelinePassed = []
        opportunity.timelineTask = []

        if (timeline !== undefined) {
            const built = buildTimelineFromActivities2(timeline)
            opportunity.timelinePassed = built.timelinePassed
            opportunity.timelineComming = built.timelineComming
            opportunity.timelineTask = built.timelineTask
        }

        // // Ordenar timeline cronológicamente (más reciente primero)
        // if (opportunity.timelinePassed.length > 0) {
        //     opportunity.timelinePassed.sort((a, b) => {
        //         const dateA = new Date(a.creation_date || a.event_date || 0);
        //         const dateB = new Date(b.creation_date || b.event_date || 0);
        //         return dateB - dateA; // Orden descendente (más reciente primero)
        //     });
        // }

    }

    return opportunity
}

function sortCommentsAndEvents(object1, object2) {
    // Verifico si el objeto es un event (estos tienen el atributo 'event_date')
    if (isEvent(object1)) {
        if (isEvent(object2)) {
            // Significa que son dos events
            if (object1.event_date < object2.event_date) {
                return 1;
            }
            if (object1.event_date > object2.event_date) {
                return -1;
            }
            return 0;
        } else {
            // Significa que object1 es un event, pero object2 es un comment
            if (object1.event_date < object2.creation_date) {
                return 1;
            }
            if (object1.event_date > object2.creation_date) {
                return -1;
            }
            return 0;
        }
    } else {
        if (isEvent(object2)) {
            // Significa que object1 es un comment, pero object2 es un event
            if (object1.creation_date < object2.event_date) {
                return 1;
            }
            if (object1.creation_date > object2.event_date) {
                return -1;
            }
            return 0;
        } else {
            // Significa que son dos comments
            if (object1.creation_date < object2.creation_date) {
                return 1;
            }
            if (object1.creation_date > object2.creation_date) {
                return -1;
            }
            return 0;
        }
    }

    function isEvent(item) {
        return item.hasOwnProperty('event_date')
    }
}
